import React from "react";
import { useTranslation } from "react-i18next";

import howCfd1 from "../../img/Markets/how-cfd-1.webp";
import howCfd2 from "../../img/Markets/how-cfd-2.webp";
import Fade from 'react-reveal/Fade';

function HowCFD() {
  const { t } = useTranslation();

  return (
    <section className="mt-[80px] xl:mt-[160px]">
      {/* Desktop */}
      <div className="hidden xl:block mx-auto max-w-[1220px]">
        {/* Row 1: text left, image right */}
        <Fade bottom>
        <div className="flex h-[288px] overflow-hidden">
          <div className="flex w-[625px] shrink-0 flex-col justify-center pr-[50px]">
            <h2 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273b4]">
              {t("markets.howcfd.title")}
            </h2>
            <p className="mt-[20px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("markets.howcfd.text1")}
            </p>
            <p className="mt-[20px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("markets.howcfd.text2")}
            </p>
          </div>
          <div className="flex-1 overflow-hidden">
            <img src={howCfd1} alt="" className="h-full w-full object-cover" />
          </div>
        </div>
        </Fade>

        {/* Row 2: image left, text right */}
        <Fade bottom delay={200}>
        <div className="flex h-[296px] overflow-hidden">
          <div className="w-[625px] shrink-0 overflow-hidden">
            <img src={howCfd2} alt="" className="h-full w-full object-cover" />
          </div>
          <div className="flex flex-1 flex-col justify-center pl-[50px]">
            <h2 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273b4]">
              {t("markets.explore.title")}
            </h2>
            <p className="mt-[20px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("markets.explore.text")}
            </p>
          </div>
        </div>
        </Fade>
      </div>

      {/* Mobile */}
      <div className="xl:hidden">
        <Fade bottom>
        <div className="px-[20px] flex flex-col gap-[30px]">
          <h2 className="font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#3273b4]">
            {t("markets.howcfd.title")}
          </h2>
          <div className="h-[220px] overflow-hidden rounded-[8px]">
            <img src={howCfd1} alt="" className="h-full w-full object-cover" />
          </div>
          <p className="font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
            {t("markets.howcfd.text1")}
          </p>
          <p className="font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
            {t("markets.howcfd.text2")}
          </p>
        </div>

        </Fade>

        <Fade bottom delay={200}>
        <div className="mt-[40px] px-[20px] flex flex-col gap-[30px]">
          <h2 className="font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#3273b4]">
            {t("markets.explore.title")}
          </h2>
          <div className="h-[220px] overflow-hidden rounded-[8px]">
            <img src={howCfd2} alt="" className="h-full w-full object-cover" />
          </div>
          <p className="font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
            {t("markets.explore.text")}
          </p>
        </div>
        </Fade>
      </div>
    </section>
  );
}

export default HowCFD;
